export function matchSinglePattern(pattern: string, url: string): boolean {
  function patternToRegex(pattern: string): RegExp {
    const regexString = pattern
      .replace(/\//g, "\\/") // Escape the slashes
      .replace(/:id/g, "[^\\/]+") // Dynamic segment

    return new RegExp("^" + regexString + "$")
  }

  // If no :id → direct comparison
  if (!pattern.includes(":id")) {
    return pattern === url
  }

  // Otherwise → regex comparison
  const regex = patternToRegex(pattern)
  return regex.test(url)
}

export function matchUrlPatterns(patterns: string[], url: string): boolean {
  return patterns.some((pattern) => matchSinglePattern(pattern, url))
}
